/* eslint-disable no-loops/no-loops */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import cIf from 'classnames';
import React from 'react';
import TranslatorManager from 'ts-translate-js';
import { noop } from 'lodash';

const tr = TranslatorManager.boundTR;

export interface IListPagingProps {
    numberOfPages: number;
    currentPage: any;
    // eslint-disable-next-line no-unused-vars
    onChange: (page: number) => void;
    firstLabel?: string;
    lastLabel?: string;
    previousLabel?: string;
    nextLabel?: string;
}

export const ListPaging: React.FC<IListPagingProps> = (props) => {
    const {
        numberOfPages = 1,
        currentPage = 1,
        onChange = noop,
        firstLabel = null,
        lastLabel = null,
        previousLabel = null,
        nextLabel = null
    } = props;

    const paging = {
        first: 'paging.first',
        last: 'paging.last',
        previous: 'paging.previous',
        next: 'paging.next'
    };

    const handlePageChange = (page: number) => {
        onChange(page);
    };

    const getHandlePageFunc = (pageI: number, selected) => {
        return function () {
            console.log(pageI);
            if (!selected) handlePageChange(pageI);
        };
    };

    const pages = [];
    const pageRange: number = 5;

    for (let i = Math.max(1, currentPage - pageRange); i <= Math.min(numberOfPages, currentPage + pageRange); i++) {
        let selected = i === currentPage;
        pages.push(
            <li key={i} className={cIf({ selected: selected })} onClick={getHandlePageFunc(i, selected)}>
                {i}
            </li>
        );
    }

    const onFirstPage: boolean = currentPage <= 1;
    const onLastPage: boolean = currentPage >= numberOfPages;

    const firstBtn = (
        <li
            key="f"
            className={cIf({ shortcut: true, disabled: onFirstPage })}
            onClick={function () {
                if (!onFirstPage) {
                    handlePageChange(1);
                }
            }}>
            {firstLabel ? firstLabel : tr(paging.first, { fallback: 'first' })}
        </li>
    );
    const lastBtn = (
        <li
            key="l"
            className={cIf({ shortcut: true, disabled: onLastPage })}
            onClick={function () {
                if (!onLastPage) {
                    handlePageChange(numberOfPages);
                }
            }}>
            {lastLabel ? lastLabel : tr(paging.last, { fallback: 'last' })}
        </li>
    );
    const prevBtn = (
        <li
            key="p"
            className={cIf({ shortcut: true, disabled: onFirstPage })}
            onClick={function () {
                if (!onFirstPage) {
                    handlePageChange(currentPage - 1);
                }
            }}>
            {previousLabel ? previousLabel : tr(paging.previous, { fallback: 'prev' })}
        </li>
    );
    const nextBtn = (
        <li
            key="n"
            className={cIf({ shortcut: true, disabled: onLastPage })}
            onClick={function () {
                if (!onLastPage) {
                    handlePageChange(currentPage + 1);
                }
            }}>
            {nextLabel ? nextLabel : tr(paging.next, { fallback: 'next' })}
        </li>
    );

    return (
        <ul className={'paging'}>
            {firstBtn}
            {prevBtn}
            {pages}
            {nextBtn}
            {lastBtn}
        </ul>
    );
};
